document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth >= 1024) {
        // Select elements in the DOM
        const langTriggers = document.querySelectorAll('.js_lang');
        const langContainers = document.querySelectorAll('.lang');

        // Select all lang elements
        for (const langTrigger of langTriggers) {
            langTrigger.addEventListener('click', () => {
                langToggle();
            });
        }

        // Toggle open class
        const langToggle = () => {
            for (let langContainer of langContainers) {
                if (langContainer.classList.contains('lang--open')) {
                    langContainer.classList.remove('lang--open');
                } else {
                    langContainer.classList.add('lang--open');
                }
            }
        }
    }
});
